import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from '../../services/auth';
import ConfirmDialog from '../../components/common/ConfirmDialog';
import '../../components/dashboard/TopBar.css'; // نفس التنسيقات

function TopBarSelection() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);

    const getPageTitle = () => {
        const path = location.pathname;
        if (path.includes('/lands')) return 'الأراضي';
        if (path.includes('/select-crop')) return 'الزراعات';
        if (path.includes('/account')) return 'إعدادات الحساب الشخصي';
        return 'ديوان الأرض';
    };

    const handleConfirmLogout = async () => {
        setIsLogoutDialogOpen(false);
        const result = await signOut();
        if (result.success) navigate('/login', { replace: true });
    };

    return (
        <>
            <header className="dashboard-topbar">


                <div className="topbar-right">
                    <div className="sidebar-header">
                        <Link to="/" className="sidebar-logo">
                            <div className="logo-info" style={{ padding: '5px 10px' }}>
                                <span className="logo-name">ديوان الأرض</span>
                                <span className="logo-desc">إدارة مزارع ذكية</span>
                            </div>
                        </Link>
                    </div>
                </div>
                <h1 className="page-title selection-title-responsive" style={{ textAlign: "center", padding: "10px 0", margin: "0" }}>
                    {getPageTitle()} | <span className="beta-label">نظام الإدارة</span>
                </h1>
                
                <style>{`
                  @media (max-width: 640px) {
                    .selection-title-responsive {
                      display: none !important;
                    }
                    .dashboard-topbar {
                      padding: 0 16px !important;
                      height: 70px !important;
                      display: flex !important;
                      flex-direction: row !important;
                      justify-content: space-between !important;
                    }
                    .topbar-right, .topbar-actions {
                      position: static !important;
                      transform: none !important;
                      flex: none !important;
                    }
                  }
                  
                  @media (min-width: 641px) and (max-width: 1024px) {
                    .dashboard-topbar {
                      height: 80px !important;
                      display: flex !important;
                      flex-direction: row !important;
                      padding: 0 24px !important;
                    }
                    .page-title {
                      display: block !important;
                      font-size: 1.25rem !important;
                    }
                  }
                `}</style>

                <div className="topbar-actions">
                    <div className="topbar-icon-btn logout-btn" onClick={() => setIsLogoutDialogOpen(true)}>
                        <span className="material-symbols-outlined">logout</span>
                        <span className="topbar-icon-label">خروج</span>
                    </div>

                    <div
                        className={`topbar-user ${location.pathname === '/account' ? 'active' : ''}`}
                        onClick={() => navigate('/account')} // التوجيه لصفحة الحساب العامة
                        style={{ cursor: 'pointer' }}
                    >
                        <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Jade" alt="User" className="topbar-avatar" />
                        <span className="topbar-icon-label">حسابي</span>
                    </div>
                </div>
            </header>

            <ConfirmDialog
                open={isLogoutDialogOpen}
                title="تأكيد تسجيل الخروج"
                message="هل أنت متأكد أنك تريد الخروج؟"
                confirmLabel="خروج"
                cancelLabel="إلغاء"
                onConfirm={handleConfirmLogout}
                onCancel={() => setIsLogoutDialogOpen(false)}
            />
        </>
    );
}

export default TopBarSelection;